import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';
import toast from 'react-hot-toast';

export interface SendProgramPlanPayload {
  docPath: string;
  clientId: string;
  programId: string;
  notify: boolean;
  startDate: string;
  message: string;
}

export const useSendProgramPlanToClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SendProgramPlanPayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_SEND_PROGRAMME_PLAN_TO_CLIENT}`,
        { data: payload },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data;
    },
    onSuccess: () => {
      // Invalidate the query to fetch fresh data so the program moves to 'sent' state
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
      queryClient.invalidateQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientProgramTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientOverview'] });
      queryClient.invalidateQueries({ queryKey: ['overview'] });
      queryClient.invalidateQueries({ queryKey: ['trainer_get_client_overview'] });
      queryClient.removeQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.removeQueries({ queryKey: ['clientProgramTab'] });
      queryClient.removeQueries({ queryKey: ['clientOverview'] });
      toast.success('Program sent successfully');
    },
    onError: (error) => {
      console.error('Failed to send program', error);
      toast.error('Failed to send program');
    },
  });
};
